import { type GridRenderCellParams } from '@mui/x-data-grid-pro';
import { type ReactElement } from 'react';

import { type Veranstaltung } from '../../../dtos.js';
import { trpc } from '../../../trpc.js';
import { FehlerCell } from '../FehlerCell.js';

export const VeranstaltungFehlerCell = (
  params: GridRenderCellParams<Pick<Veranstaltung, 'akaVeranstaltungId'>>,
): ReactElement => {
  const { data } = trpc.veranstaltung.getHealthByVeranstaltung.useQuery({
    akaVeranstaltungId: params.row.akaVeranstaltungId,
  });

  return <FehlerCell healthFindings={data} />;
};
